module.exports = __webpack_public_path__ + "static/img/page7_img3.c657d31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/page7_img3.jpg
// module id = D5R5
// module chunks = 1